import React from 'react';
import { Loader as SageLoader, SageClassnames } from '@kajabi/sage-react';
import { useUiResourceContext } from '../../contexts';

const Loader = () => {
  const { loading } = useUiResourceContext();

  if (!loading) return null;

  return (
    <SageLoader
      data-testid="copy-magic-loader"
      loading
      type={SageLoader.TYPES.SPINNER}
      label="Generating content, this may take up to 1 minute..."
      className={SageClassnames.SPACERS.LG_BOTTOM}
    />
  );
};

export default Loader;
